import { z } from "zod";

import { typedObjectKeys } from "../../utils/typedObjects.js";

/**
 * A schema is necessary to define each entity's configuration; this is a utility function to convert an enum to one!
 */
export const convertEnumToSchema = <T extends string>(
  enumObj: Record<T, T>,
): z.ZodEnum<[T, ...T[]]> => {
  const [first, ...rest] = typedObjectKeys(enumObj);
  // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- https://github.com/lukastaegert/eslint-plugin-tree-shaking/issues/71
  return z.enum([first!, ...rest]);
};
